export const normaliseStrArray = (stringArray: string[]): string[] | undefined => {
  const trimmed = stringArray.map((s) => s.trim()).filter((s) => s !== "");

  return trimmed.length > 0 ? trimmed : undefined;
};

export const normaliseEmailArray = (stringArray: string[]): string[] | undefined => {
  const normalised = stringArray.map((s) => s.trim().toLowerCase()).filter((s) => s !== "");

  return normalised.length > 0 ? normalised : undefined;
};
